module.exports = __webpack_public_path__ + "static/media/2-ano.cbc225f1.png";